/**
 * Copy text to clipboard with fallbacks for HTTP (non-secure context) and older browsers.
 * Must be called from a user gesture (click handler).
 */
export async function copyTextToClipboard(text) {
  if (text == null || text === '') {
    throw new Error('Nothing to copy');
  }

  const value = String(text);

  if (navigator.permissions?.query) {
    try {
      const status = await navigator.permissions.query({ name: 'clipboard-write' });
      if (status.state === 'denied') {
        throw new Error('Clipboard permission denied');
      }
    } catch {
      // clipboard-write permission name is not supported in all browsers
    }
  }

  if (navigator.clipboard?.writeText && window.isSecureContext) {
    try {
      await navigator.clipboard.writeText(value);
      return true;
    } catch {
      // Fall through to legacy copy
    }
  }

  if (copyWithExecCommand(value)) {
    return true;
  }

  throw new Error('Copy failed');
}

function copyWithExecCommand(text) {
  if (typeof document === 'undefined') {
    return false;
  }

  const textarea = document.createElement('textarea');
  textarea.value = text;
  textarea.setAttribute('readonly', '');
  textarea.style.position = 'fixed';
  textarea.style.top = '0';
  textarea.style.left = '0';
  textarea.style.width = '2em';
  textarea.style.height = '2em';
  textarea.style.padding = '0';
  textarea.style.border = 'none';
  textarea.style.outline = 'none';
  textarea.style.boxShadow = 'none';
  textarea.style.background = 'transparent';
  textarea.style.opacity = '0';
  textarea.style.pointerEvents = 'none';

  document.body.appendChild(textarea);
  textarea.focus();
  textarea.select();
  textarea.setSelectionRange(0, text.length);

  let copied = false;
  try {
    copied = document.execCommand('copy');
  } catch {
    copied = false;
  }

  document.body.removeChild(textarea);
  return copied;
}
